import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { authData } from "./redux/auth/authSlice";
import Login from "./components/pages/Login/login";

import DashboardLayout from "./Layout/DashboardLayout/layout";
import ContentLayout from "./Layout/ContentLayout";
import UspContentLayout from "./Layout/UspContentLayout";
import CategoryLayout from "./Layout/CategoryLayout";
import TenantsLayout from "./Layout/TenantsLayout";
import EngageLayout from "./Layout/EngageLayout";
import EventsLayout from "./Layout/EventsLayout";
import UserRoleLayout from "./Layout/UserRoleLayout";
import ViewTenantLayout from "./Layout/viewTenantLayout";
import UserInfoLayout from "./Layout/userInfoLayout";
import ListTopicsLayout from "./Layout/listTopicsLayout";
import CourseUsersLayout from "./Layout/courseUsersLayout";
import TotalUsersLayout from "./Layout/TotalUsersLayout";
import TotalContentLayout from "./Layout/TotalContentLayout";
import TotalProgramsLayout from "./Layout/TotalProgramsLayout";
import TotalCoursesLayout from "./Layout/TotalCoursesLayout";
import TotalLiveSessionLayout from "./Layout/TotalLiveSessionLayout";
import UsersTodayLayout from "./Layout/UsersTodayLayout";
import SessionsTodayLayout from "./Layout/SessionsTodayLayout";
import ContentTodayLayout from "./Layout/ContentTodayLayout";
import StandAloneCoursesLayout from "./Layout/StandAloneCoursesLayout";
import StandAloneContentLayout from "./Layout/StandAloneContentLayout";
import SessionViewLayout from "./Layout/SessionViewLayout";
import ViewTopicLayout from "./Layout/viewTopicLayout";
import ReportLayout from "./Layout/ReportLayout";
import CourseCreationLayout from "./Layout/CourseCreationLayout";
import UserEngagementLayout from "./Layout/userengagementLayout";
import UsersLayout from "./Layout/UsersLayout";
import UserInfoDashboardLayout from "./Layout/userInfoDasboardLayout";
import AddContentLayout from "./Layout/AddContentLayout";
import ProformaInvoice from "./Layout/ProformaInvoice";
import ObjectUsersLayout from "./Layout/objectUsersLayout";
import TotalAttendanceLayout from "./Layout/TotalAttendanceLayout";
import TotalRevenueLayout from "./Layout/TotalRevenueLayout";
import FeedbackLayout from "./Layout/FeedbackLayout";
import "./App.scss";

function App() {
  const userDetails = useSelector(authData);

  return (
    <div className="App">
      <Router>
        {userDetails === 0 ? (
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="*" element={<Login />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<DashboardLayout />} />
            <Route path="/landingscreen" element={<DashboardLayout />} />
            <Route path="/landingscreen/totalusers" element={<TotalUsersLayout />} />
            <Route path="/landingscreen/totalprograms" element={<TotalProgramsLayout />} />
            <Route path="/landingscreen/totalcourses" element={<TotalCoursesLayout />} />
            <Route path="/landingscreen/totallivesession" element={<TotalLiveSessionLayout />} />
            <Route path="/landingscreen/totalattendance" element={<TotalAttendanceLayout />} />
            <Route path="/landingscreen/totalrevenue" element={<TotalRevenueLayout />} />
            <Route path="/landingscreen/totalcontent" element={<TotalContentLayout />} />
            <Route path="/landingscreen/userstoday" element={<UsersTodayLayout />} />
            <Route path="/landingscreen/todaysession" element={<SessionsTodayLayout />} />
            <Route path="/landingscreen/contenttoday" element={<ContentTodayLayout />} />
            <Route path="/category/content" element={<ContentLayout />} />
            <Route path="/uspcontent" element={<UspContentLayout />} />
            <Route path="/category" element={<CategoryLayout />} />
            <Route path="/uspcontent/sessionView" element={<SessionViewLayout />} />
            <Route path="/uspcontent/coursecreation" element={<CourseCreationLayout />} />
            <Route path="/organization" element={<TenantsLayout />} />
            <Route path="/engage" element={<EngageLayout />} />
            <Route path="/events" element={<EventsLayout />} />
            <Route path="/report" element={<ReportLayout />} />
            <Route path="/report/users" element={<FeedbackLayout />} />
            <Route path="/userRole" element={<UserRoleLayout />} />
            <Route path="/organization/viewTenant" element={<ViewTenantLayout />} />
            <Route path="/organization/viewTenant/userInfo" element={<UserInfoLayout />} />
            <Route path="/listTopics" element={<ListTopicsLayout />} />
            <Route path="/organization/viewTenant/courseusers" element={<CourseUsersLayout />} />
            <Route path="/organization/viewTenant/objectUsers" element={<ObjectUsersLayout />} />
            <Route path="/uspcontent/viewtopic" element={<ViewTopicLayout />} />
            <Route path="/landingscreen/totalcourses/standalonecourses" element={<StandAloneCoursesLayout />} />
            <Route path="/landingscreen/totalcontent/standalonecontent" element={<StandAloneContentLayout />} />
            <Route path="/engage/userengagement" element={<UserEngagementLayout />} />
            <Route path="/users" element={<UsersLayout />} />
            <Route path="/addcontent" element={<AddContentLayout />} />
            <Route path="/proformaInvoice" element={<ProformaInvoice />} />
            <Route path="/landingscreen/userInfo" element={<UserInfoDashboardLayout />} />
          </Routes>
        )}
      </Router>
    </div>
  );
}

export default App;
